export default "__VITE_ASSET__DSww_YME__"